module.exports = __webpack_public_path__ + "static/media/apptitude-logo.c1574cee.svg";